<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import _find from 'lodash/find'
import moment from 'moment'

import eventService from 'api/event'
import EventCard1 from 'components/EventCard1'
import dateUtils from 'utils/dateUtils'
import analyticsLib from 'lib/analytics'
import TRACKING_EVENTS from 'constants/trackingEvents'

export default {
  name: 'event-carousel',
  props: {
    venueId: {
      type: String,
      required: true,
    },
    slidesToScroll: {
      type: Number,
      required: false,
      default: 3,
    },
    slidesToShow: {
      type: Number,
      required: false,
      default: 3,
    },
    //THEMEING
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  components: {
    EventCard1,
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      events: (state) => state.event.events,
    }),
  },
  data() {
    return {
      loading: false,
      carouselOptions: {
        scrollLock: true,
        draggable: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: this.slidesToShow,
              slidesToScroll: this.slidesToScroll || this.slidesToShow,
              infinite: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    }
  },
  methods: {
    getEvents() {
      this.loading = true

      const now = moment()
      // if it is before 6AM lets go back a day incase a venue is looking after midnight
      if (now.hours() < 6) now.subtract(1, 'day')

      return eventService
        .listByVenueId(this.venueId, {
          dateStart: dateUtils.toUTCTimestampWithoutTime(now),
          limit: this.eventCount || 25,
          sort: 'dateStart',
        })
        .then((result) => {
          this.loading = false

          this.$store.dispatch('setCurrentEvents', result.data)
          this.$store.dispatch('setCurrentEventsTotal', result.count)
        })
        .catch(() => {
          this.loading = false
        })
    },
    onEventClicked(target) {
      const eventId = target.getAttribute('data-id')

      const event = _find(this.events, {
        id: eventId,
      })

      this.$emit('eventClicked', event)

      analyticsLib.trackEvent(TRACKING_EVENTS.ViewedEvent, {
        venueId: event.venue.id,
        venueName: event.venue.name,
        eventId: event.id,
      })
    },
  },
  mounted() {
    if (!this.events || !this.events.length) {
      this.getEvents()
    }
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventCarousel/index.vue